import { Injectable } from '@angular/core';
import { INavMenu } from '../navbar/navbar.component';

@Injectable({
  providedIn: 'root'
})
export class NavbarService {

  slectedItemValue: INavMenu = { title: "",disableOption:true};

  constructor() { }

  getNavMenu(): INavMenu[] {
    return [
      { title: 'Basics of Patents',  disableOption: false },
      { title: 'Basics of Patents Quiz',disableOption: true},
      { title: 'Patent Drawing',disableOption:  true},
      { title: 'Patent Search',disableOption:  true},
      { title: 'Patent Search Quiz',disableOption: true },
      { title: 'Patent Drafting', disableOption:  true},
      { title: 'Patent Drafting Quiz',disableOption:true },
      { title: 'Patent Filing',disableOption:true  }
    ];
  }

  

  
  saveActiveNavItem(navItemSelected) {
    this.slectedItemValue.title = navItemSelected;
    this.slectedItemValue.disableOption = true;
  }


  getActiveNavItem() {
    return this.slectedItemValue.title;
  }

  setDisable(disableValue){
    this.slectedItemValue.title = disableValue;
  }


 // doSomethingElseUseful() { }

}
